import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MainState } from 'app/app.providers';
import { boardStages } from 'app/trello/models/board-stages';

// ------------------------------------------------------

export const selectMainState = createFeatureSelector<MainState>('main');

export const selectBoardState = createSelector(
  selectMainState,
  state => state.boardSummaryReport,
);

// ------------------------------------------------------

export const selectBoardSummaryState = createSelector(
  selectBoardState,
  state => state.boardSummary,
);

export const selectBoardSummary = createSelector(
  selectBoardSummaryState,
  state => state.data,
);

export const selectBoardSummaryDateRange = createSelector(
  selectBoardSummaryState,
  state => state.dateRange,
);

export const selectBoardSummaryLoading = createSelector(
  selectBoardSummaryState,
  state => state.loading,
);

export const selectBoardSummaryLoaded = createSelector(
  selectBoardSummaryState,
  state => state.loaded,
);

export const selectBoardSummaryError = createSelector(
  selectBoardSummaryState,
  state => state.error,
);

// ------------------------------------------------------

export const selectComparableBoardSummaryState = createSelector(
  selectBoardState,
  state => state.comparableBoardSummary,
);

export const selectComparableBoardSummary = createSelector(
  selectComparableBoardSummaryState,
  state => state.data,
);

export const selectComparableBoardSummaryDateRange = createSelector(
  selectComparableBoardSummaryState,
  state => state.dateRange,
);

export const selectComparableBoardSummaryLoading = createSelector(
  selectComparableBoardSummaryState,
  state => state.loading,
);

export const selectComparableBoardSummaryLoaded = createSelector(
  selectComparableBoardSummaryState,
  state => state.loaded,
);

export const selectComparableBoardSummaryError = createSelector(
  selectComparableBoardSummaryState,
  state => state.error,
);

// ------------------------------------------------------

// Labels selectors
export const selectLabelsState = createSelector(
  selectBoardState,
  state => state.labels,
);

export const selectLabels = createSelector(
  selectLabelsState,
  state => state.data,
);

export const selectLabelsLoading = createSelector(
  selectLabelsState,
  state => state.loading,
);

export const selectLabelsLoaded = createSelector(
  selectLabelsState,
  state => state.loaded,
);

export const selectLabelsError = createSelector(
  selectLabelsState,
  state => state.error,
);

// ------------------------------------------------------

export const selectListsState = createSelector(
  selectBoardState,
  state => state.lists,
);

export const selectLists = createSelector(
  selectListsState,
  state => state.data,
);

export const selectListsLoading = createSelector(
  selectListsState,
  state => state.loading,
);

export const selectListsLoaded = createSelector(
  selectListsState,
  state => state.loaded,
);

export const selectListsError = createSelector(
  selectListsState,
  state => state.error,
);

// ------------------------------------------------------

export const selectMembersState = createSelector(
  selectBoardState,
  state => state.members,
);

export const selectMembers = createSelector(
  selectMembersState,
  state => state.data,
);

export const selectMembersLoading = createSelector(
  selectMembersState,
  state => state.loading,
);

export const selectMembersLoaded = createSelector(
  selectMembersState,
  state => state.loaded,
);

export const selectMembersError = createSelector(
  selectMembersState,
  state => state.error,
);

// ------------------------------------------------------

export const selectStages = createSelector(
  selectBoardState,
  () => boardStages(),
);

// ------------------------------------------------------

export const selectBoardSummaryAnyLoading = createSelector(
  selectBoardSummaryLoading,
  selectLabelsLoading,
  selectListsLoading,
  selectMembersLoading,
  (boardSummaryLoading, labelsLoading, listsLoading, membersLoading) =>
    boardSummaryLoading || labelsLoading || listsLoading || membersLoading,
);

export const selectBoardSummaryAnyError = createSelector(
  selectBoardSummaryError,
  selectLabelsError,
  selectListsError,
  selectMembersError,
  (boardSummaryError, labelsError, listsError, membersError) =>
    boardSummaryError || labelsError || listsError || membersError,
);

// ------------------------------------------------------

export const selectBoardSummaryBasicLoaded = createSelector(
  selectBoardSummaryLoaded,
  selectLabelsLoaded,
  selectListsLoaded,
  selectMembersLoaded,
  (boardSummaryLoaded, labelsLoaded, listsLoaded, membersLoaded) =>
    boardSummaryLoaded && labelsLoaded && listsLoaded && membersLoaded,
);

export const selectBoardSummaryAllLoaded = createSelector(
  selectBoardSummaryBasicLoaded,
  selectComparableBoardSummaryLoaded,
  (boardSummaryBasicLoaded, comparableBoardSummaryLoaded) =>
    boardSummaryBasicLoaded && comparableBoardSummaryLoaded,
);

// ------------------------------------------------------
